import { render } from "./Afgerond.vue?vue&type=template&id=4425b803&scoped=true"
import script from "./Afgerond.vue?vue&type=script&lang=js"
export * from "./Afgerond.vue?vue&type=script&lang=js"

import "./Afgerond.vue?vue&type=style&index=0&id=4425b803&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-dielnimmer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4425b803"]])

export default __exports__